import React from 'react'

const Detail = ({handleSubmit, handleChange, loading, group, create}) => {
    const entityType = group?.type || 'group';
    const isCompany = entityType === 'company';

    return (
        <div className='detailGroup my-3'>
            {create && !group?.id && (
                <div className="grp_inp mb-4">
                    <h4 className="group-settings-header mb-3">What would you like to create?</h4>
                    <div className="type-selector-wrapper">
                        <label className={`type-selector-option ${!isCompany ? 'active' : ''}`}>
                            <input
                                type="radio"
                                name="type"
                                value="group"
                                checked={!isCompany}
                                onChange={handleChange}
                            />
                            <div className="type-selector-content">
                                <i className="fa fa-users"></i>
                                <span>Group</span>
                                <small>Create a community group</small>
                            </div>
                        </label>
                        <label className={`type-selector-option ${isCompany ? 'active' : ''}`}>
                            <input
                                type="radio"
                                name="type"
                                value="company"
                                checked={isCompany}
                                onChange={handleChange}
                            />
                            <div className="type-selector-content">
                                <i className="fa fa-building"></i>
                                <span>Company</span>
                                <small>Create a business company</small>
                            </div>
                        </label>
                    </div>
                </div>
            )}

            <h4 className="group-settings-header mb-2">
                {isCompany ? 'Company' : 'Group'} Name & Description
            </h4>
            <div className="grp_inp">
                <label>{isCompany ? 'Company' : 'Group'} Name (required)</label>
                <input type="name" name="name" onChange={handleChange} value={group?.name || ''} />
            </div>
            <div className="grp_inp">
                <label>{isCompany ? 'Company' : 'Group'} Description (required)</label>
                <textarea name='description' onChange={handleChange} defaultValue={group?.description || ''} />
            </div>
            {isCompany && (
                <>
                    <div className="grp_inp">
                        <label>Location (optional)</label>
                        <input type="text" name="city" onChange={handleChange} value={group?.city || ''} placeholder="e.g. New York, USA" />
                    </div>
                    <div className="grp_inp">
                        <label>Website URL (optional)</label>
                        <input type="url" name="url" onChange={handleChange} value={group?.url || ''} placeholder="https://example.com" />
                    </div>
                </>
            )}
            <button onClick={handleSubmit} className='btncs px-5'>{loading ? 'Saving...' : 'Save & Continue'}</button>
        </div>
    )
}

export default Detail
